module.exports = __webpack_public_path__ + "media/images/google-play-badge_275px-4cb5f349.png";